const anims = require("./animations.js");

let loaded = false;

function addItemEvent(specTables) {
  loaded = true;
  const items = document.querySelectorAll('.ui-menu-item-wrapper');

  items.forEach(item => {
    item.addEventListener('click', e => {
      const id = parseInt(e.target.id.replace('ui-id-', '')) - 1;
      const matchingSection = specTables[id];

      if (matchingSection) {
        anims.scrollTo(document.scrollingElement || document.documentElement, matchingSection, 500);
      }
    })
  })
}

window.addEventListener('load', () => {
  const dropdownSelect = document.getElementById('choose-spec-button');

  if (!dropdownSelect) return;

  //Set default selected option
  const selectText = document.querySelector('.ui-selectmenu-text');
  const firstSelectItem = document.querySelector('.js-specification');
  selectText.innerHTML = firstSelectItem.dataset.specTitle;

  //Add dropdown items to select
  const select = document.getElementById('choose-spec');
  const specTables = document.querySelectorAll('.js-specification');
  specTables.forEach(table => {
    const opt = document.createElement("option");
    opt.value = table.id;
    opt.text = table.dataset.specTitle;
    select.add(opt, null);
  });

  dropdownSelect.addEventListener('click', () => loaded === false ? addItemEvent(specTables) :
    null);
});
